import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  container: {
    maxWidth: '330px',
    gap: '32px',
    '& > div': {
      height: '56px',
    },
    [theme.breakpoints.down('xs')]: {
      maxWidth: '272px',
    },
  },
  titleModal: {
    fontSize: 24,
    fontWeight: 700,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.33,
    letterSpacing: 'normal',
    textAlign: 'center',
    color: theme.palette.primary.main,
    marginTop: theme.spacing(2),
  },
  desciptionModal: {
    fontSize: 20,
    fontWeight: 400,
    fontStretch: 'normal',
    fontStyle: 'normal',
    lineHeight: 1.4,
    letterSpacing: 0.15,
    textAlign: 'center',
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      maxWidth: 260,
    },
  },

  iconeVisibility: {
    color: 'currentColor',
    padding: 0,
  },
  cadastroTxt: {
    fontFamily: 'Inter',
    fontSize: 14,
    letterSpacing: -0.58,
  },

  errorMessage: {
    color: theme.appColors.errorRed,
    fontFamily: 'Inter',
    margin: 10,
  },
  btnAcessarSingle: {
    width: '100%',
    height: '56px',
    borderRadius: '4px',
    backgroundColor: theme.screens.login.CardLogin.btnAcessarBackground,
    '&:hover': {
      backgroundColor: theme.screens.login.CardLogin.btnAcessarBackgroundHover,
    },
    padding: theme.spacing(1),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: '20px',
    },
  },
  btnAcessar: {
    width: '100%',
    maxWidth: '210px',
    height: '56px',
    borderRadius: '4px',
    padding: theme.spacing(1),
    margin: theme.spacing(1, 0),
    [theme.breakpoints.down('sm')]: {
      padding: 0,
      margin: 0,
    },
  },
  btnAcessarText: {
    width: '100%',
    fontFamily: theme.typography.inter.fontFamily,
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '46px',
    color: theme.screens.login.CardLogin.btnAcessarText,
  },
  link: {
    fontFamily: theme.typography.inter.fontFamily,
    fontSize: '13px',
    lineHeight: '15px',
    color: theme.appColors.primaryColor,
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
    cursor: 'pointer',
    margin: theme.spacing(1, 0),
  },
  linkSingle: {
    fontFamily: theme.typography.inter.fontFamily,
    fontSize: '13px',
    fontWeight: 500,
    lineHeight: '15px',
    color: theme.screens.login.SingleCardAccess.link,
    textDecoration: 'underline',
    textUnderlineOffset: '3px',
    cursor: 'pointer',
    [theme.breakpoints.down('xs')]: {
      marginTop: '-8px',
    },
  },
}));
